// 2024 Evoker (SRD 5.2.1). Save spells read these where a Wizard's spell is prepared (playerSpellSaveDamageSource.js),
// and spell attacks in classFeatures/wizard/evokerAttacks.js.
export const EVOKER_SUBCLASS_ID = 'evoker';
export const POTENT_CANTRIP_FEATURE_ID = 'wizard:evoker:potent-cantrip';
export const EMPOWERED_EVOCATION_FEATURE_ID = 'wizard:evoker:empowered-evocation';
export const SCULPT_SPELLS_FEATURE_ID = 'wizard:evoker:sculpt-spells';
export const OVERCHANNEL_FEATURE_ID = 'wizard:evoker:overchannel';
/** Empowered Evocation's addition to a Wizard Evocation spell's damage. */
export const empoweredEvocationBonus = intelligenceModifier => Math.max(0, Math.floor(Number(intelligenceModifier) || 0));

const evoker = Object.freeze({
  id: EVOKER_SUBCLASS_ID, definitionId: 'wizard:evoker', classId: 'wizard',
  name: 'Evoker', selectionLevel: 3,
  description: 'Create explosive elemental effects.',
  features: Object.freeze([
    {
      id: 'wizard:evoker:evocation-savant', name: 'Evocation Savant', level: 3,
      description: 'Choose two Wizard spells from the Evocation school, each of which must be no higher than level 2, and add them to your spellbook for free. In addition, whenever you gain access to a new level of spell slots in this class, you can add one Wizard spell from the Evocation school to your spellbook for free. The chosen spell must be of a level for which you have spell slots.',
      presentation: { kind: 'passive' }, contracts: [],
    },
    {
      id: POTENT_CANTRIP_FEATURE_ID, name: 'Potent Cantrip', level: 3,
      description: 'Your damaging cantrips affect even creatures that avoid the brunt of the effect. When you cast a cantrip at a creature and you miss with the attack roll or the target succeeds on a saving throw against the cantrip, the target takes half the cantrip’s damage (if any) but suffers no additional effect from the cantrip.',
      presentation: { kind: 'passive' }, contracts: [],
    },
    {
      id: SCULPT_SPELLS_FEATURE_ID, name: 'Sculpt Spells', level: 6,
      description: 'You can create pockets of relative safety within the effects of your evocations. When you cast an Evocation spell that affects other creatures that you can see, you can choose a number of them equal to 1 plus the spell’s level. The chosen creatures automatically succeed on their saving throws against the spell, and they take no damage if they would normally take half damage on a successful save.',
      presentation: { kind: 'passive' }, contracts: [],
    },
    {
      id: EMPOWERED_EVOCATION_FEATURE_ID, name: 'Empowered Evocation', level: 10,
      description: 'Whenever you cast a Wizard spell from the Evocation school, you can add your Intelligence modifier to one damage roll of that spell.',
      presentation: { kind: 'passive' }, contracts: [],
    },
    {
      id: OVERCHANNEL_FEATURE_ID, name: 'Overchannel', level: 14,
      description: 'You can increase the power of your spells. When you cast a Wizard spell with a spell slot of levels 1–5 that deals damage, you can deal maximum damage with that spell on the turn you cast it. The first time you do so, you suffer no adverse effect. If you use this feature again before you finish a Long Rest, you take 2d12 Necrotic damage for each level of the spell slot immediately after you cast it. This damage ignores Resistance and Immunity. Each time you use this feature again before finishing a Long Rest, the Necrotic damage per spell level increases by 1d12.',
      presentation: { kind: 'passive' }, contracts: [],
    },
  ]),
});

export default evoker;
